import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import AppFooter from '../components/AppFooter';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex flex-col bg-background"
      data-testid="not-found-page"
    >
      <div className="flex-1 flex items-center justify-center p-8">
        <Card className="border-border bg-card w-full max-w-md text-center">
          <CardContent className="p-10 space-y-6">
            <h1 className="text-6xl font-bold tracking-tight text-foreground">
              404
            </h1>
            <h2 className="text-xl font-bold uppercase tracking-tight text-foreground">
              PAGE NOT FOUND
            </h2>
            <p className="text-sm text-muted-foreground">
              The page you're looking for doesn't exist
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center pt-2">
              <Button onClick={() => navigate('/dashboard')}>
                GO TO DASHBOARD
              </Button>
              <Button variant="outline" onClick={() => navigate('/login')}>
                GO TO LOGIN
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
      <AppFooter noBorder />
    </div>
  );
};

export default NotFoundPage;
